<template>
  <div class="questionnaireDetails">
    <!-- 抬头 -->
    <div class="head">
      <h4>问卷查看</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <!-- 抬头结束 -->
    <!-- 内容 -->
    <div class="questionnaireDetails-contents">
      <!-- 标题 -->
      <div class="preview-contents-box-head">
        <h4 class="preview-contents-box-head-h4">
          {{form.survey_name}}</h4>
      </div>
      <!-- 内容区域-->
      <div class="preview-contents-box-contents">
        <div class="container">
          <el-form
            ref="form"
            :model="form"
          >
            <!-- 遍历已创建的选项渲染 -->
            <div
              class="item"
              v-for="(item, index) in form.survey_detail"
              :key="index"
            >
              <!-- <el-form-item :label="(index+1)+''">
                <div class="item_title">
                  <span
                    v-text="item.question_name"
                    v-if="item.question_type!=='paragraph'"
                  ></span>
                </div>
              </el-form-item> -->
              <div
                class="hdsuiagdhuia"
                v-if="item.question_type!=='paragraph' "
              >
                <div class="hahasodk">
                  <div class="hahasodk-img">
                    <img src="../../../assets/image/questionnaires/组 600.png">
                  </div>
                  <div class="hahasodk-text">{{index+1}}</div>
                </div>
                <!-- <el-form-item :label="(index+1)+''"> -->
                <el-form-item>
                  <div class="item_title">
                    <span
                      v-if="item.question_type!=='paragraph'"
                      v-text="item.question_name"
                    ></span>
                  </div>
                </el-form-item>
              </div>
              <!-- 单项填空 -->
              <div v-if="item.question_type==='input'">
                <el-input
                  style="width:54.5%;"
                  class="disabled"
                  placeholder="请输入信息"
                  v-model="item.answer"
                ></el-input>
              </div>
              <!-- 手机验证 -->
              <div v-else-if="item.question_type==='phoneValidation'">
                <div>
                  <!-- 第一排 -->
                  <div style="display:flex;">
                    <span class="matrix-left-poh">手机号</span>
                    <el-input
                      style="width:685px;"
                      placeholder="请输入手机号"
                      v-model="item.answer[0]"
                    ></el-input>
                  </div>
                  <!-- 第一排 结束-->
                  <!-- 第二排 -->
                  <div style="display:flex; margin-top:20px;">
                    <span class="matrix-left-poh">验证码</span>
                    <el-input
                      style="width:550px;"
                      placeholder="请输入验证码"
                      v-model="item.answer[1]"
                    ></el-input>
                    <el-button
                      disabled
                      style="background: #484c7f; color: #fff; margin-left:20px;"
                    >获取验证码
                    </el-button>
                  </div>
                  <!-- 第二排 结束-->
                </div>
              </div>
              <!-- 城市选择 -->
              <div v-else-if="item.question_type==='cascader'">
                <el-cascader
                  style="width:38%;"
                  v-model="item.answer"
                  :options="cityList"
                >
                </el-cascader>
              </div>
              <!-- 单选  -->
              <el-form-item
                v-if="item.question_type==='radio'"
                :prop="`survey_detail.${index}.answer`"
              >
                <div class="horizontal">
                  <div
                    class="warp"
                    v-for="(elm, i) in item.options"
                    :key="i"
                  >
                    <!--    @input="danxuanInput(index,item.answer)"  切换清空数据-->
                    <el-radio-group v-model.trim="item.answer">
                      <el-radio :label="elm.id">
                        {{elm.option_name}}
                      </el-radio>
                    </el-radio-group>

                    <div
                      v-if="elm.is_fill==1 && item.answer==elm.id"
                      class="beizhu"
                    >
                      <el-input
                        placeholder="请输入内容"
                        v-model="elm.value"
                      ></el-input>
                    </div>

                  </div>
                </div>
              </el-form-item>
              <!-- 多选 -->
              <el-form-item
                v-if="item.question_type==='checkbox'"
                :prop="`survey_detail.${index}.answer`"
              >
                <div class="horizontal">
                  <div
                    class="warp"
                    v-for="(elm, i) in item.options"
                    :key="i"
                  >
                    <!-- 多选切换情况数据  @change="duoxuanchange(i, index,item.answer.indexOf(elm.id))" -->
                    <el-checkbox
                      v-model="item.answer"
                      :label="elm.id"
                    >{{elm.option_name}}
                    </el-checkbox>
                    <div
                      v-if="elm.is_fill==1 && item.answer.indexOf(elm.id)!=-1"
                      class="beizhu"
                    >
                      <el-input
                        placeholder="请输入内容"
                        v-model="elm.value"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <!-- 下拉选择 -->
              <div v-else-if="item.question_type === 'select'">
                <el-select
                  v-model="item.answer"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(elm, i) in item.options"
                    :key="i"
                    :label="elm.option_name"
                    :value="elm.option_name"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- 矩阵填空 -->
              <div v-else-if="item.question_type==='matrix'">
                <div
                  class="matrix"
                  v-for="(elm, i) in item.options"
                  :key="i"
                >
                  <div class="matrix-left"> {{elm.option_name}}</div>
                  <el-input
                    style="width:685px;"
                    v-model="item.answer[i]"
                    class="disabled"
                    placeholder="请输入信息"
                  ></el-input>
                </div>
              </div>
              <!-- 富文本 -->
              <el-form-item
                v-if="item.question_type==='paragraph'"
                :prop="`survey_detail.${index}.answer`"
              >
                <div
                  class="fuwenben"
                  v-html="item.question_name"
                ></div>
              </el-form-item>
              <!-- 上传文件 -->
              <el-form-item
                v-if="item.question_type==='upload'"
                :prop="`survey_detail.${index}.answer`"
              >
                <div class="uploadStle">
                  <div
                    v-for="(upitem,upindex ) in item.answer.split(',')"
                    class="upview"
                    @click="uploadOpenData(upitem)"
                  >
                    <div
                      class="upview-icon"
                      v-if="upitem!=''"
                    >
                      <i class="el-icon-document"></i>
                    </div>
                    <div v-if="upitem!=''">{{upitem}}</div>
                  </div>
                  <!-- <el-upload
                    v-for="(upitem,upindex) in item.answer.split(',')"
                    class="upload-demo"
                    :action="action"
                    :file-list="[{name:item.answer.split(',')[upindex],url:item.answer.split(',')[upindex]}]"
                  >
                  </el-upload> -->
                  <!-- <el-upload
                    v-model="item.answer.split(',')"
                    class="upload-demo"
                    :action="action"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {
                      return handleRemove(file, fileList, index)}"
                    :on-success="(response, file, fileList) => {
                      return handleAvatarSuccess(response, file, fileList, index)}"
                    multiple
                    :limit="10"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :data="uploadData"
                    :before-upload="wenBeforeUpload"
                    :on-progress="onProgressTest"
                  >
                    <el-button
                      disabled
                      size="small"
                      type="primary"
                    >点击上传</el-button>
                    <div
                      slot="tip"
                      class="el-upload__tip inage-form-item-warn"
                    >可上传多个PPT、PDF、图片等格式文件（最大上限50M，文件名称请勿添加 "," ）</div>
                  </el-upload> -->
                </div>
              </el-form-item>

            </div>
          </el-form>
        </div>
      </div>
      <!-- 内容区域 结束-->
      <!-- 盒子底部图片 -->
      <div class="monotype">
        <img src="../../../assets/image/questionnaires/蒙版组 134.png">
      </div>
      <!-- 盒子底部图片 结束 -->
    </div>
    <!-- 底部 -->
    <div class="preview-bottom">
      <div class="contents-right-ending-log"><img
          src="../../../assets/image/questionnaires/共识云logo长方.png"
        >
      </div>
      <div class="contents-right-ending-text">您已完成本次问卷，感谢您的帮助与支持</div>
    </div>
    <!-- 底部 结束 -->
  </div>
  <!-- 内容 结束 -->
  </div>
</template> 
 
<script>
import city from "../../../utils/city";
import getCode from '../../../components/getCode/index.vue'
export default {
  name: 'questionnaireDetails',
  components: {
    getCode
  },
  data () {
    return {
      ruleForm: {},
      cityList: [],
      value: '',
      form: {},
      uploadData: { key: "", token: "" },
      action: `http://up-z1.qiniup.com`, //http://up-z1.qiniup.com
      fileList: [],
    }
  },
  created () {
    this.cityList = city.city
    this.getQuestionnairesView(this.$route.query.id, this.$route.query.userid, this.$route.query.survey_id)
  },
  methods: {
    //获取详情
    async getQuestionnairesView (id, userid, survey_id) {
      const { data: data } = await this.$http.post('survery/check-detail', { id, userid, survey_id })
      this.form = data.data
      console.log(this.form);
      // console.log(data.data.survey_detail);
      // //.split(',')
      // data.data.survey_detail.map(item => {
      //   if (item.question_type === "upload") {
      //     console.log(item.answer);
      //   }
      // })
    },
    //获取接口修改手机号格式  //1提交问卷的时候使用 
    getAipPhone () {
      this.form.survey_detail.map(item => {
        if (item.question_type == 'phoneValidation') {
          this.ruleForm.phone = item.name[0]
        }
      })
    },
    //返回  
    backProject () {
      this.$router.back()
    },
    //输入手机号 //1提交问卷的时候使用 
    phoneValidationChange (value) {
      this.ruleForm.phone = value
    },
    //上传前
    async wenBeforeUpload (file) {
      const is50M = file.size / 1024 / 1024 < 50;
      if (!is50M) {
        this.$message.error("上传图片大小不能超过 50MB!");
        return false
      }
      // console.log(file); 
      let suffix = file.name.substring(file.name.lastIndexOf("."));//.txt
      //获取七牛云的token 
      const { data: data } = await this.$http.get('system/qiniuToken')
      this.uploadData.token = data.data.token
      //file.uid + 
      this.uploadData.key = file.uid + file.name;
      return true
    },
    //文件上传时
    onProgressTest (event, file, fileList) {
      let index = 0
      // 只有fileList 跟file 里面的uid是唯一的互相对应的
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i
        }
      })
      // 获取动态的进度
      let percent = parseInt(event.percent)
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 98) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName('el-upload-list__item')[index]
            let progressText = dom.getElementsByClassName('el-progress__text')
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0
              progressText[0].innerText = '98%'
              progressText[0].style.opacity = 1
            }
          }
        })
      })
    },
    //文件上传成功
    handleAvatarSuccess (res, file, fileList, index) {
      if (res.key != '' || res.key != undefined || res.key != null) {
        this.form.survey_detail[index].answer += `https://resources.gongshicloud.com/${res.key}` + ','
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
      } else {
        this.$message.error('上传失败');
      }
    },
    //移除后 
    handleRemove (file, fileList, index) {
      this.aaa = ''
      let apiUrl = ''
      let qiniuUrl = ''
      fileList.map(item => {
        if (item.response != undefined) {
          qiniuUrl += `https://resources.gongshicloud.com/${item.response.key}` + ','
        }
        if (item.url) {
          apiUrl += item.url + ','
        }
      })
      this.aaa = apiUrl + qiniuUrl
      this.form.survey_detail[index].answer = this.aaa
    },
    //点击每一个上传后的文件
    handlePreview (file) {
      console.log(file);
    },
    //超出长度提示 
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //单选切换清空数据
    danxuanInput (index, value) {
      this.form.survey_detail[index].options.map(item => {
        if (item.id != value) {
          item.value = ''
        }
      })
    },
    //多选切换清空数据
    duoxuanchange (i, index, aaaa) {
      //i 多选里面的item
      //index 最外侧第几个
      if (aaaa == -1) {
        this.form.survey_detail[index].options[i].value = ''
      }
    },
    //打开上传文件
    uploadOpenData (url) {
      window.open(url)
    }
  }
}

</script>
<style lang="less" scoped>
.questionnaireDetails {
  //标题
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  //内容
  .questionnaireDetails-contents {
    position: relative;
    width: 100%;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 0px 10px #d0d3fb;

    .preview-contents-box-head {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 57px 0 40px 0;
      .preview-contents-box-head-h4 {
        font-size: 18px;
        color: #5a5a5a;
      }
    }
    .preview-contents-box-contents {
      // padding: 0 515px 0 238px;
      padding: 0 50px 50px 80px;

      .item {
        margin-bottom: 40px;
      }
      .warp {
        // display: flex;
        // align-items: center;
        margin-bottom: 5px;
      }
      .matrix {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .matrix-left {
          width: 70px;
          text-align: right;
          margin-right: 25px;
        }
      }
      .matrix-left-poh {
        width: 45px;
        text-align: right;
        margin-right: 25px;
      }
      .horizontal {
        // display: flex;
      }

      /deep/ .el-radio {
        line-height: 40px;
        margin-right: 30px;
      }

      /deep/ .el-checkbox {
        line-height: 40px;
        margin-right: 30px;
      }

      // /deep/ .el-form-item__label {
      //   position: relative;
      //   z-index: 1;
      //   margin-right: 13px;
      //   color: #fff;

      //   &::before {
      //     content: "";
      //     z-index: -1;
      //     position: absolute;
      //     top: 7px;
      //     left: -11px;
      //     width: 34px;
      //     height: 28px;
      //     background: url("../../../assets/image/questionnaires/组 600.png")
      //       no-repeat;
      //   }
      // }
      // /deep/ .item_title {
      //   margin-bottom: 15px;
      // }
      .hdsuiagdhuia {
        display: flex;
        // align-items: center;
      }
      .hahasodk {
        position: relative;
        top: 6px;
        display: flex;
        margin-right: 15px;
        .hahasodk-text {
          position: absolute;
          top: 3px;
          left: -3px;
          width: 34px;
          height: 28px;
          text-align: center;
          font-size: 14px;
          color: #fff;
        }
        .hahasodk-img {
          width: 34px;
          height: 28px;
        }
      }
      /deep/ .item_title {
        margin-bottom: 10px;
      }
    }

    .monotype {
      position: absolute;
      bottom: 60px;
      right: 55px;
      width: 263px;
      height: 118px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .preview-bottom {
    padding: 26px 0 58px 0;
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 0px 10px #d0d3fb;
    .contents-right-ending-log {
      width: 128px;
      height: 36px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .contents-right-ending-text {
      margin-top: 19px;
      color: #484c7f;
      font-size: 16px;
    }
  }

  .fuwenben {
    // margin-top: 42px;
  }
  .beizhu {
    width: 60%;

    /deep/ .el-input__inner {
      border-radius: 0 !important;
      border-top: 0 !important;
      border-left: 0 !important;
      border-right: 0 !important;
      border: 1px solid #dcdfe6;
    }
  }

  .upview {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    &:hover {
      font-size: 14px;
      color: #409eff;
    }
    .upview-icon {
      margin-right: 15px;
    }
  }

  .uploadStle {
    width: 70%;
    position: relative;
    top: -20px;
    left: 0;
  }
}
</style>  